export default "__VITE_ASSET__q34xDiDC__"